/*
 * @Descripttion: card
 * @Author: zenghua.wang
 * @Date: 2021-09-28 15:54:32
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-13 10:34:09
 */
import { isEmpty, setPx, getTextByAnalysis } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: 600
    },
    height: {
      type: [Number, String],
      default: 120
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      cardHandle: null,
      cardList: [],
      dataList: []
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              // background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          // position: 'relative',
          width:
            this.category === 'report'
              ? this.width || '100%'
              : setPx(this.width),
          height:
            this.category === 'report'
              ? this.height || 'auto'
              : setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    spanCard() {
      return Math.floor(24 / this.option.col)
    },
    styleContent() {
      return {
        textAlign: this.option.textAlign
      }
    },
    styleImage() {
      return { width: this.device === 'desktop' ? '100%' : '80%' }
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    'option.refresh'(val) {
      if (val) this.loadDataList()
    }
  },
  methods: {
    getProp(type) {
      if (isEmpty(this.option.column)) return null
      let list = this.option.column.filter((item) => {
        return item.type === type
      })
      if (isEmpty(list)) {
        return null
      } else {
        return list[0]['prop']
      }
    },
    async loadDataList() {
      if (!this.apiId) return
      // 参数设置
      let restParams = []
      let query = {}

      // 过滤条件
      this.option.reqParams.map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }

        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      try {
        this.loading = true
        let res = await this.$http({
          method: this.option.reqMethod,
          url: mock.getUrl(false) + this.apiId,
          data: restParams, // body
          params: query // query
        })
        if (!isEmpty(res.data)) {
          this.dataList = res.data
          this.setOption()
          this.onRefresh()
        }
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
        this.option.refresh = false
      }
    },
    onRefresh() {
      this.cardHandle && clearInterval(this.cardHandle)
      this.cardHandle = null
      if (this.option.refreshTime > 0 && this.disabled) {
        this.cardHandle = setInterval(() => {
          this.loadDataList()
        }, this.option.refreshTime)
      }
    },
    setLink(link, row) {
      let url = getTextByAnalysis(link, row)
      if (isEmpty(url)) return
      if (url.includes('http')) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    }
  },
  created() {
    this.loadDataList()
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    clearInterval(this.cardHandle)
  }
}
